/**
 * MyCopro - Syndic Bottom Navigation
 * Barre de navigation fixe en bas pour l'espace Syndic
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Building2, 
  ClipboardList,
  FileText,
  Calendar
} from 'lucide-react';

// ============================================================================
// CONFIGURATION DES ONGLETS
// ============================================================================

const TABS = [
  { 
    id: 'dashboard', 
    label: 'Accueil', 
    icon: LayoutDashboard, 
    path: '/syndic' 
  },
  { 
    id: 'residences', 
    label: 'Résidences', 
    icon: Building2, 
    path: '/syndic/residences' 
  },
  { 
    id: 'requests', 
    label: 'Demandes', 
    icon: ClipboardList, 
    path: '/syndic/requests' 
  },
  { 
    id: 'documents', 
    label: 'Documents', 
    icon: FileText, 
    path: '/syndic/documents' 
  },
  { 
    id: 'calendar', 
    label: 'Calendrier', 
    icon: Calendar, 
    path: '/syndic/calendar' 
  },
];

// ============================================================================
// COMPOSANT PRINCIPAL
// ============================================================================

export const SyndicBottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Déterminer l'onglet actif
  const getActiveTab = () => {
    const path = location.pathname;
    
    // Cas exact pour dashboard
    if (path === '/syndic') return 'dashboard';
    
    // Autres cas
    if (path.startsWith('/syndic/residences')) return 'residences';
    if (path.startsWith('/syndic/requests')) return 'requests';
    if (path.startsWith('/syndic/documents')) return 'documents';
    if (path.startsWith('/syndic/calendar')) return 'calendar';
    
    return 'dashboard';
  };

  const activeTab = getActiveTab();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 safe-area-bottom">
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive 
                  ? 'text-emerald-600' 
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon 
                size={22} 
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : 'font-medium'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default SyndicBottomNav;
